var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8933 3.07357C13.5528 2.73291 13.1485 2.46267 12.7036 2.2783C12.2586 2.09392 11.7817 1.99902 11.3 1.99902C10.8183 1.99902 10.3414 2.09392 9.89643 2.2783C9.45146 2.46267 9.04717 2.73291 8.70667 3.07357L8 3.78024L7.29333 3.07357C6.60554 2.38578 5.67269 1.99938 4.7 1.99938C3.72731 1.99938 2.79446 2.38578 2.10666 3.07357C1.41887 3.76137 1.03247 4.69422 1.03247 5.66691C1.03247 6.6396 1.41887 7.57245 2.10666 8.26024L2.81333 8.96691L8 14.1536L13.1867 8.96691L13.8933 8.26024C14.234 7.91974 14.5042 7.51545 14.6886 7.07048C14.873 6.6255 14.9679 6.14857 14.9679 5.66691C14.9679 5.18525 14.873 4.70831 14.6886 4.26334C14.5042 3.81836 14.234 3.41408 13.8933 3.07357V3.07357Z",
    fill: "#FE0404"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRed);
export default __webpack_public_path__ + "static/media/heartRed.919cb939fb4e67eacf14c2d136e90727.svg";
export { ForwardRef as ReactComponent };